import {PaymentCardsActionTypes} from '../ActionTypes/PaymentCardsActionTypes';

class PaymentCardsActions {
  static getPaymentCards = payload => {
    return {
      type: PaymentCardsActionTypes.GET_PAYMENT_CARDS,
      payload: payload,
    };
  };

  static deletePaymentCard = payload => {
    return {
      type: PaymentCardsActionTypes.DELETE_PAYMENT_CARDS_LIST,
      payload: payload,
    };
  };

  static updatePaymentCard = payload => {
    return {
      type: PaymentCardsActionTypes.UPDATE_PAYMENT_CARD,
      payload: payload,
    };
  };

  static updatePaymentCardList = payload => {
    return {
      type: PaymentCardsActionTypes.UPDATE_PAYMENT_CARD_LIST,
      payload: payload,
    };
  };
}

export default PaymentCardsActions;
